import React from "react";
import PropTypes from "prop-types";
import getStoriesByCollection from "../../../utils";
import { CollectionName } from "../../atoms/collection-name";
import CommonStoryCard from "../../molecules/common-story-card";
import "./one-row-three-col.m.css";

const OneRowThreeCol = ({ collection = {} }) => {
  const stories = getStoriesByCollection(collection);
  if(stories.length < 1) {
    return null;
  }
  return (
    <div className="full-width" styleName="row-container">
      <div className="container" styleName="row-wrapper">
        <div styleName="section-heading">
          <CollectionName collection={collection} />
        </div>
        <div styleName="wrapper">
          {stories.slice(0, 3).map(story => (
            <CommonStoryCard story={story} key={story.id} />
          ))}
        </div>
      </div>
    </div>
  );
};

OneRowThreeCol.propTypes = {
  collection: PropTypes.object
};
export default OneRowThreeCol;
